module.exports = __webpack_public_path__ + "files/b008fceeabc7c30b81a1ca59bc80a9cd.png";